import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsStepComponent } from './documents-step.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PosTakePhotoModule } from 'src/app/shared/pos-take-photo/pos-take-photo.module';



@NgModule({
  declarations: [DocumentsStepComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AccordionModule,
    PosTakePhotoModule
  ],
  exports:[DocumentsStepComponent]
})
export class DocumentsStepModule { }
